/**
 * Honest copy after a project is saved.
 * Mention only the channels that were attempted. Never surface a raw
 * Unauthorized (or other transport) error in the sentence the agent sees.
 */
function projectSaveMessage({ created, email, push }) {
  const attempts = [];
  if (email) attempts.push({ kind: 'email', ok: email.ok === true });
  if (push) attempts.push({ kind: 'notification', ok: push.ok === true });
  const failed = attempts.filter((attempt) => !attempt.ok);
  const sent = attempts.filter((attempt) => attempt.ok);
  if (failed.length === 0) {
    return created ? 'Project checklist sent to client!' : 'Project updated successfully!';
  }
  if (sent.length === 0) {
    return created
      ? "The project was saved, but your client wasn't notified."
      : "The project was updated, but your client wasn't notified.";
  }
  const saved = created ? 'Project sent.' : 'Project updated.';
  const delivered = sent.map((attempt) => (
    attempt.kind === 'email' ? 'an email' : 'a notification'
  )).join(' and ');
  const missed = failed.map((attempt) => (
    attempt.kind === 'email' ? "the email couldn't be sent" : "the notification couldn't be sent"
  )).join(' and ');
  return `${saved} Your client got ${delivered}, but ${missed}.`;
}

module.exports = {
  projectSaveMessage,
};
